// Registry van code-smell regels op UmlClassMember-niveau — zelfde patroon als
// ImportStrategyRegistry.js: platte lijst van { id, check, message }, nieuwe
// regel toevoegen = 1 object erbij, geen aparte infrastructuur nodig.
// check(member) heeft toegang tot alles wat een geparste member heeft
// (name, text, memberKind, description, paramCount) — dus toekomstige regels
// zoals "missing comment" (member.description leeg) of "no intent name"
// (generieke method-namen als DoIt/Handle) passen in dezelfde lijst.
export const MEMBER_SMELL_RULES = [
    {
        id: 'tooManyParams',
        check: function check(member) {
            return member.memberKind === 'method' && (member.paramCount ?? 0) > 3;
        },
        message: function message(member) {
            return `Too many params (${member.paramCount})`;
        },
    },
    {
        id: 'tooManyDependencies',
        check: function check(member) {
            return member.memberKind === 'constructor' && (member.paramCount ?? 0) > 3;
        },
        message: function message(member) {
            return `Too many dependencies (${member.paramCount}) \u2014 possible SRP violation`;
        },
    },
];

/**
 * Runs every rule in MEMBER_SMELL_RULES against a member, returns the
 * messages of the rules that matched.
 * @param {object} member
 * @returns {string[]}
 */
export function getMemberSmells(member) {
    return MEMBER_SMELL_RULES.filter(function matches(rule) {
        return rule.check(member);
    }).map(function toMessage(rule) {
        return rule.message(member);
    });
}
